import { Component, Input, ViewEncapsulation, ChangeDetectionStrategy } from '@angular/core';
@Component({
  selector: 'lib-panel',
  templateUrl: './lib-panel.component.html',
  styleUrls: ['./lib-panel.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class LibPanelComponent {
  @Input() noPadding?: boolean = false;
  @Input() noMargin?: boolean = false;
}
